import { Card } from "@/src/components/wrappers/Card";
import { Booking } from "../../model";
import { Button } from "@/src/components/ui/button";
import { Switch } from "@/src/components/ui/switch";
import { useState } from "react";
import { EditBookingMailingSettingsModal } from "../../EditBookingMailingSettings";

const MailingSection = ({ booking }: { booking: Booking }) => {
  const [updateMailingSettingsOpen, setUpdateMailingSettingsOpen] = useState(false);

  return (
    <div className="flex w-full gap-6">
      <Card className="flex flex-col basis-[664px] grow gap-6">
        <div className="flex justify-between items-center">
          <h3 className="text-lg font-semibold">Mailing Settings</h3>
          <Button
            onClick={() => {
              setUpdateMailingSettingsOpen(true);
            }}
            variant="link"
          >
            Edit
          </Button>
        </div>
        {booking?.contractTemplate && (
          <div className="flex gap-2.5 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm">
            <span className="mt-0.5 shrink-0 text-amber-500" aria-hidden>
              ⚑
            </span>
            <p>
              <b>{booking.contractTemplate.toUpperCase()} charter — automated client email is off by default.</b> These
              broker-led bookings only email the client when you switch a notification on here. The client booking page
              stays current regardless; the client sees it when you share the link.
            </p>
          </div>
        )}
        <div className="flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <span className="text-base font-normal">Create booking notification: </span>
            <Switch disabled checked={booking?.mailingSettings?.bookingConfirmation} />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-base font-normal">Booking updates notifications: </span>
            <Switch disabled checked={booking?.mailingSettings?.bookingUpdates} />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-base font-normal">
              Payment confirmation notifications (for manually handled payments in HELMs App):
            </span>
            <Switch disabled checked={booking?.mailingSettings?.paymentConfirmations} />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-base font-normal">Payment reminders notifications: </span>
            <Switch disabled checked={booking?.mailingSettings?.paymentReminders} />
          </div>
        </div>
      </Card>
      {updateMailingSettingsOpen && (
        <EditBookingMailingSettingsModal
          open={updateMailingSettingsOpen}
          setOpen={setUpdateMailingSettingsOpen}
          initialSettings={booking?.mailingSettings}
          bookingId={booking?.id}
        />
      )}
      <div className="flex flex-col basis-[664px] grow gap-6"></div>
    </div>
  );
};

export default MailingSection;
